/**
 * sponsored-drivers-sds.js
 * Handles the animated stacking carousel for Sponsored Drivers
 */
(function () {
  'use strict';

  function initDriverCarousel() {
    const images = document.querySelectorAll('.sds-drivers-image-card');
    const infoPanels = document.querySelectorAll('.sds-drivers-slide-info');
    const nextBtn = document.querySelector('.sds-nav-next');
    const prevBtn = document.querySelector('.sds-nav-prev');

    if (!images.length || !infoPanels.length || !nextBtn || !prevBtn) return;

    let activeIndex = 0;
    const total = images.length;

    function render() {
      // Update Images Stack
      images.forEach((imgCard, i) => {
        const index = parseInt(imgCard.dataset.index);
        const rot = parseInt(imgCard.dataset.rot) || 0;
        
        let scale, opacity, z, rotate, y, zIndex;

        if (index === activeIndex) {
          scale = 1;
          opacity = 1;
          z = 0;
          rotate = 0;
          y = 0;
          zIndex = 40;
        } else {
          scale = 0.95;
          opacity = 0.7;
          z = -100;
          rotate = rot;
          y = 0;
          zIndex = total + 2 - i;
        }

        imgCard.style.transform = `scale(${scale}) translateY(${y}px) translateZ(${z}px) rotate(${rotate}deg)`;
        imgCard.style.opacity = opacity;
        imgCard.style.zIndex = zIndex;
      });

      // Update Info Panels
      infoPanels.forEach((panel) => {
        const index = parseInt(panel.dataset.index);
        if (index === activeIndex) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }

    function handleNext() {
      activeIndex = (activeIndex + 1) % total;
      render();
    }

    function handlePrev() {
      activeIndex = (activeIndex - 1 + total) % total;
      render();
    }

    nextBtn.addEventListener('click', handleNext);
    prevBtn.addEventListener('click', handlePrev);

    // Initial render
    render();
  }

  document.addEventListener('DOMContentLoaded', initDriverCarousel);
  // Also run if Shopify loads section dynamically
  initDriverCarousel();
})();
